var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative",staticStyle:{"min-height":"300px"}},[(_vm.loading)?_c('le-loading'):_vm._e(),_c('FullCalendar',{ref:"fullCalendar",staticClass:"mb-3",attrs:{"options":_vm.calendarOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }